import { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { LanguageOptions } from '../../entities/LanguageOptions';
import { toast } from 'react-toastify';
import './Team.css';

export const TeamGroupCreate = () => {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [structures, setStructures] = useState([]);
  const [form, setForm] = useState({ title: '', teamStructureId: '', mainLanguageId: 1 });
  const { structureId } = useParams();

  useEffect(() => {
    apiRequests.team.getStructures(50).then((res) => {
      const items = res.items || [];
      if (structureId) {
        setForm((prev) => ({ ...prev, teamStructureId: structureId }));
      } else if (items.length > 0) {
        setForm((prev) => ({ ...prev, teamStructureId: items[0].id }));
      }
      setStructures(items.map((i) => ({ value: i.id, label: i.title })));
      setLoading(false);
    });
  }, [structureId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) {
      toast.error('Введите название');
      return;
    }
    setSaving(true);
    try {
      await apiRequests.team.createGroup(form);
      toast.success('Группа создана');
      navigate(structureId ? `/team-structures/${structureId}` : '/team-structures');
    } catch {
      toast.error('Ошибка создания');
    } finally {
      setSaving(false);
    }
  };

  const handleBack = () => {
    navigate(structureId ? `/team-structures/${structureId}` : '/team-structures');
  };

  if (loading) {
    return <div className="team-loading">Загрузка...</div>;
  }

  return (
    <div className="team-page">
      <div className="team-header">
        <div>
          <button className="team-back" onClick={handleBack}>← Назад</button>
          <h1 className="team-title">Новая группа</h1>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="team-form">
        <div className="team-form-section">
          <div className="team-form-row">
            <div className="team-form-field">
              <label>Название <span className="required">*</span></label>
              <input
                type="text"
                value={form.title}
                onChange={(e) => setForm((prev) => ({ ...prev, title: e.target.value }))}
                placeholder="Введите название группы"
                className="team-input"
              />
            </div>
            <div className="team-form-field">
              <label>Структура</label>
              <select
                value={form.teamStructureId}
                onChange={(e) => setForm((prev) => ({ ...prev, teamStructureId: e.target.value }))}
                className="team-select"
              >
                {structures.map((s) => (
                  <option key={s.value} value={s.value}>{s.label}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="team-form-row">
            <div className="team-form-field" style={{ maxWidth: 200 }}>
              <LanguageOptions onSelect={(val) => setForm((prev) => ({ ...prev, mainLanguageId: val }))} />
            </div>
          </div>
        </div>

        <div className="team-form-actions">
          <button type="button" className="team-btn-cancel" onClick={handleBack}>
            Отмена
          </button>
          <button type="submit" className="team-btn-submit" disabled={saving}>
            {saving ? 'Создание...' : 'Создать группу'}
          </button>
        </div>
      </form>
    </div>
  );
};
